import { LocationPhoto } from "../../features/profile/provider/LocationsContent"
import ImageCarousel from "../../features/shared/components/ImageCarousel"

export type ModalComponentType = {
  type: "imageCarousel"
  onCancel?: boolean
  onSubmit?: boolean
  props: {
    locationPhotos: LocationPhoto[]
    text: {
      imageAriaLabel: string
      previousButton: string
      nextButton: string
    }
  }
}

export const modalComponentRegistry: {
  [K in ModalComponentType["type"]]: React.FC<
    Extract<ModalComponentType, { type: K }>["props"]
  >
} = {
  imageCarousel: ({ locationPhotos, text }) => (
    <ImageCarousel
      carouselChildren={locationPhotos.map((photo) => ({
        id: photo.id,
        imageUrl: photo.imageUrl,
        imageAltText: photo.name || photo.fileName,
        imageLabel: photo.name || photo.fileName,
        imageDescription: photo.description,
        imageAriaLabel: `${text.imageAriaLabel} - ${photo.name || photo.fileName}`,
        isLoading: !!photo.isLoading,
      }))}
      text={{
        previousButton: text.previousButton,
        nextButton: text.nextButton,
      }}
    />
  ),
  // Add other modal component key value pairs here as needed
}
